import type { profile as en } from '@/i18n/locales/en/profile';
import type { Translation } from '@/i18n/types';

export const profile: Translation<typeof en> = {
  title: 'Profil',
  lead: 'Votre nom, votre langue et vos paramètres de confidentialité.',
  pendingBadge: '{{count}} demande de consentement en attente',
  nav: {
    label: 'Menu du profil',
    profile: 'Profil',
    consents: 'Consentements',
    preferences: 'Préférences',
    subscription: 'Abonnement',
  },
  preferredLanguage: 'Langue préférée',
  preferredLanguageOptional: 'Langue préférée (facultatif)',
  preferredLanguageUnset: 'Non définie',
  timezoneUnset: 'Valeur par défaut du déploiement',
  saved: 'Enregistré.',
  save: 'Enregistrer',
  privateFieldsHint:
    'Ces quatre champs sont privés — vous seul pouvez les voir ou les modifier, quel que soit qui peut voir le reste de votre dossier.',
  details: {
    title: 'Coordonnées',
    rolesTitle: 'Rôles',
  },
  regionAndTimezone: {
    title: 'Région et fuseau horaire',
  },
  fields: {
    name: 'Nom',
    email: 'E-mail',
    nickname: 'Surnom',
    region: 'Région',
    regionUnset: 'Non définie',
    regionHint: 'Le pays pour lequel vos statistiques/rapports sont localisés.',
    timezone: 'Fuseau horaire des statistiques',
    timezoneHint: 'Le calendrier sur lequel vos journées de statistiques sont découpées.',
    gender: 'Genre',
    birthdate: 'Date de naissance',
    height: 'Taille (cm)',
    weight: 'Poids (kg)',
  },
};
